export default __webpack_public_path__ + "static/media/Gellix-ExtraBold.413780e8.woff";